import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/vendas/origem/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function listOrigem(empresa_cnpj, columnParam, whereParam) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[${columnParam}]=${whereParam}`,
    "GET",
    headers
  );
}

export function showOrigem(id, empresa_cnpj, include) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include[vendas.origem]=${include}` : ""
    }`,
    "GET",
    headers
  );
}

export function createOrigem(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export function updateOrigem(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export function deleteOrigem(id, empresa_cnpj) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
}
